export const listingBookingSettings = {
  section01: {
    title: "Reservas directas de este anuncio",
  },
  motor: {
    activeTitle: "Motor activo",
    inactiveTitle: "Motor inactivo",
    activeDesc: "Los huéspedes pueden reservar este anuncio directamente desde su enlace.",
    inactiveDesc: "Las reservas directas están desactivadas para este anuncio.",
    statusOn: "Activo",
    statusOff: "Inactivo",
  },
  payment: {
    title: "¿Cuándo paga el huésped?",
    onArrival: {
      name: "Pago a la llegada",
      hint: "Reserva gratis, paga al llegar.",
    },
    online: {
      name: "Pago online",
      hint: "Paga al confirmar la reserva.",
    },
  },
  common: {
    saving: "Guardando…",
    onlyOnlineBadge: "Solo pago online",
  },
  hold: {
    title: "Tiempo de hold",
    desc: "El calendario se bloquea mientras el huésped completa el pago.<br>Si no paga en el tiempo indicado, <strong>la disponibilidad se libera automáticamente</strong>.",
  },
  units: {
    min: "min",
    hour: "hora",
    hours: "horas",
  },
  partial: {
    title: "Cobro parcial",
    cardTitle: "Permitir pagar solo una parte al reservar",
    descOn: "<strong>Activado.</strong> El huésped podrá pagar el <strong>{percent}%</strong> ahora y el resto antes de llegar (o pagar el total).",
    descOff: "<strong>Desactivado.</strong> El huésped paga el <strong>total</strong> al reservar.",
    blockTitle: "El resto se paga en el alojamiento",
    blockOn: "<strong>Activado.</strong> El huésped paga <strong>solo el {percent}%</strong> online; el resto lo abona <strong>al llegar</strong> (no podrá pagar el total por internet).",
    blockOff: "<strong>Desactivado.</strong> El huésped puede elegir pagar el {percent}% o el total online.",
  },
  reminder: {
    title: "Recordatorio de saldo",
    cardTitle: "Enviar recordatorio de pago del saldo pendiente",
    daysBefore: "{count} día antes | {count} días antes",
    descOn: "<strong>Activado.</strong> <strong>{daysBefore}</strong> de la llegada (sobre las 09:00, hora de la propiedad) se envía al huésped un enlace para pagar el saldo pendiente por <strong>WhatsApp y correo</strong>.",
    descOff: "<strong>Desactivado.</strong> El huésped no recibe recordatorio para pagar el saldo online antes de llegar.",
    daysLabel: "Días antes de la llegada",
    hint: "Se envía una sola vez, y solo a huéspedes con saldo pendiente. Si el resto se paga en el alojamiento, no se envía.",
  },
  approve: {
    title: "Aprobar reservas",
    cardTitle: "Aprobar cada reserva antes de confirmarla",
    descOn: "<strong>Activado.</strong> Cada reserva queda <strong>pendiente de tu aprobación</strong>: recibes un aviso y decides si la aceptas o la rechazas. No se confirma hasta que tú la apruebas.",
    descOff: "<strong>Desactivado.</strong> Las reservas se <strong>confirman solas</strong> al completar el pago. Actívalo si prefieres revisar y aprobar tú mismo cada solicitud.",
  },
  toasts: {
    statusUpdatedAll: "Estado actualizado en todas las unidades.",
    statusUpdated: "Estado actualizado.",
    statusError: "No se pudo actualizar.",
    paymentUpdated: "Forma de pago actualizada.",
    paymentError: "No se pudo guardar la forma de pago.",
    partialUpdated: "Cobro parcial actualizado.",
    partialError: "No se pudo guardar el cobro parcial.",
    reminderUpdated: "Recordatorio actualizado.",
    reminderError: "No se pudo guardar el recordatorio.",
    saved: "Guardado.",
    saveError: "No se pudo guardar.",
    linkCopied: "Link copiado.",
    copyError: "No se pudo copiar.",
  },
  share: {
    whatsappText: "Hola 👋 Te comparto el enlace para reservar: {link}",
  },
};
